import { Outlet, Navigate, useLocation } from "react-router-dom";

import { MenuView } from "../pages/Privada/Menu/Menu.View";
import { AutenticacaoModule } from "src/Contexto/auth";
import { isPendenteCadastroUsuario } from "src/pages/Privada/CadastroInicial/CadastroInicial.Dto";

export const PrivateRoute = () => {
  const { user, isLoaded, empresaId, userId } = AutenticacaoModule();
  const location = useLocation();

  if (!user && isLoaded) {
    if (window.location.pathname !== "/login") {
      localStorage.setItem(
        "redirectAfterLogin",
        window.location.pathname + window.location.search,
      );
    }
    return <Navigate to="/login" />;
  }

  const pendenteCadastroUsuario = isPendenteCadastroUsuario(userId);

  if (user && isLoaded && Number(empresaId) === 0) {
    if (!location.pathname.startsWith("/cadastro-inicial")) {
      return <Navigate to="/cadastro-inicial/empresa" replace />;
    }
  }

  if (user && isLoaded && Number(empresaId) > 0) {
    if (pendenteCadastroUsuario) {
      if (
        !location.pathname.startsWith("/cadastro-inicial/usuario") &&
        !location.pathname.startsWith("/minhaconta")
      ) {
        return <Navigate to="/minhaconta" replace />;
      }
    } else {
      if (location.pathname.startsWith("/cadastro-inicial")) {
        return <Navigate to="/inicio" replace />;
      }
    }
  }

  return (
    <MenuView>
      <Outlet />
    </MenuView>
  );
};

